import {Divider, Layout} from 'antd';
import React from 'react';
import AssumptionsTabs from './AssumptionsTabs';

const Assumptions = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <AssumptionsTabs/>
      <Divider/>
    </Layout>
  );
};

export default Assumptions;
